export default "__VITE_ASSET__CLomEysF__"